export function createNewNameWB() {
    const date = new Date();
    const roomID = window.location.pathname.split("/")[1];
    const newNameWBDateStr = roomID +
        "_" +
        ("00" + date.getDate()).slice(-2) +
        ("00" + (date.getMonth() + 1)).slice(-2) +
        date.getFullYear() +
        "_" +
        ("00" + date.getHours()).slice(-2) +
        ("00" + date.getMinutes()).slice(-2) +
        ("00" + date.getSeconds()).slice(-2);
    return newNameWBDateStr;
}
;
